var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _g4, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321317830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_624_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 34,
    height: 33
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b119fac092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.75 14.6055H33.2427V47.0001H0.75V14.6055Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_624_19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9276 47.0075C14.8276 47.0075 12.7803 46.6091 10.8423 45.8232C8.83584 45.0095 7.0356 43.8144 5.49205 42.2709C3.94851 40.7273 2.75288 38.9271 1.93918 36.9206C1.15324 34.9827 0.754883 32.9348 0.754883 30.8348C0.754883 28.7348 1.15324 26.6875 1.93918 24.7496C2.75288 22.7425 3.94851 20.9423 5.49205 19.3993C7.0356 17.8552 8.83584 16.6601 10.8423 15.8464C12.7803 15.0605 14.8276 14.6621 16.9276 14.6621C19.0276 14.6621 21.0754 15.0605 23.0134 15.8464C25.0199 16.6601 26.8201 17.8552 28.3636 19.3993C29.9072 20.9428 31.1023 22.7425 31.916 24.7496C32.7019 26.6869 33.1003 28.7348 33.1003 30.8348C33.1003 32.9348 32.7019 34.9827 31.916 36.9206C31.1023 38.9271 29.9072 40.7273 28.3636 42.2709C26.8201 43.8144 25.0199 45.0095 23.0134 45.8232C21.0754 46.6091 19.0276 47.0075 16.9276 47.0075ZM16.9276 16.1377C13.1622 16.1377 9.39682 17.5713 6.53072 20.4374C0.797381 26.1707 0.797381 35.4989 6.53072 41.2322C12.2635 46.965 21.5916 46.965 27.325 41.2322C33.0578 35.4989 33.0578 26.1707 27.325 20.4374C24.4583 17.5713 20.6929 16.1377 16.9276 16.1377Z",
    fill: "#13373F"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5301 20.3228C16.3419 20.3228 16.1538 20.2514 16.0105 20.1074C15.7237 19.8207 15.7237 19.3561 16.0105 19.0688L17.9694 17.1104C18.2561 16.8237 18.7213 16.8237 19.008 17.1104C19.2947 17.3972 19.2947 17.8624 19.008 18.1491L17.0491 20.108C16.9058 20.2508 16.7176 20.3228 16.5301 20.3228ZM22.0911 14.7617C21.903 14.7617 21.7155 14.6897 21.5715 14.5464C21.2848 14.2596 21.2848 13.7944 21.5715 13.5077L34.4809 0.598343C34.7682 0.31162 35.2328 0.31162 35.5196 0.598343C35.8063 0.885067 35.8063 1.35028 35.5196 1.63701L22.6102 14.5464C22.4668 14.6897 22.2793 14.7617 22.0911 14.7617Z",
    fill: "#13373F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1526 24.5224C17.9645 24.5224 17.7764 24.4504 17.633 24.307C17.3463 24.0203 17.3463 23.5551 17.633 23.2684L22.4387 18.4626C22.7255 18.1759 23.1907 18.1759 23.4774 18.4626C23.7641 18.7499 23.7641 19.2146 23.4774 19.5013L18.6717 24.307C18.5283 24.4504 18.3408 24.5224 18.1526 24.5224ZM26.1038 16.5712C25.9157 16.5712 25.7276 16.4998 25.5842 16.3558C25.2975 16.0691 25.2975 15.6039 25.5842 15.3172L38.68 2.22139C38.9667 1.93467 39.4319 1.93467 39.7187 2.22139C40.0054 2.50868 40.0054 2.97333 39.7187 3.26005L26.6229 16.3558C26.4795 16.4992 26.2914 16.5712 26.1038 16.5712Z",
    fill: "#13373F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6706 27.8264C20.4831 27.8264 20.2949 27.7544 20.1516 27.611C19.8648 27.3243 19.8648 26.8591 20.1516 26.5724L25.8107 20.9133C26.0974 20.6265 26.562 20.6265 26.8493 20.9133C27.1361 21.2006 27.1361 21.6652 26.8493 21.9519L21.1902 27.611C21.0469 27.7544 20.8587 27.8264 20.6706 27.8264ZM29.359 19.138C29.1715 19.138 28.9833 19.066 28.84 18.9226C28.5532 18.6359 28.5532 18.1707 28.84 17.884L41.9845 4.73946C42.2712 4.45273 42.7364 4.45273 43.0232 4.73946C43.3099 5.02618 43.3099 5.4914 43.0232 5.77812L29.8786 18.9226C29.7353 19.066 29.5471 19.138 29.359 19.138Z",
    fill: "#13373F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9749 30.3441C23.7868 30.3441 23.5986 30.2727 23.4553 30.1293C23.1686 29.8426 23.1686 29.3774 23.4553 29.0906L28.261 24.2849C28.5477 23.9982 29.013 23.9982 29.2997 24.2849C29.5864 24.5716 29.5864 25.0368 29.2997 25.3236L24.4939 30.1293C24.3506 30.2727 24.1625 30.3441 23.9749 30.3441ZM31.9261 22.3934C31.738 22.3934 31.5498 22.3215 31.4065 22.1781C31.1197 21.8914 31.1197 21.4262 31.4065 21.1394L44.5023 8.04366C44.789 7.75693 45.2542 7.75693 45.5409 8.04366C45.8277 8.33038 45.8277 8.7956 45.5409 9.08232L32.4451 22.1781C32.3018 22.3215 32.1136 22.3934 31.9261 22.3934Z",
    fill: "#13373F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.174 31.9673C27.9865 31.9673 27.7983 31.8953 27.655 31.752C27.3683 31.4653 27.3683 31 27.655 30.7133L29.6133 28.7544C29.9006 28.4677 30.3653 28.4677 30.6525 28.7544C30.9393 29.0411 30.9393 29.5064 30.6525 29.7931L28.6936 31.752C28.5503 31.8953 28.3622 31.9673 28.174 31.9673ZM33.7357 26.4062C33.5476 26.4062 33.3594 26.3343 33.2161 26.1909C32.9293 25.9042 32.9293 25.439 33.2161 25.1522L46.1254 12.2429C46.4121 11.9562 46.8774 11.9562 47.1641 12.2429C47.4508 12.5296 47.4508 12.9948 47.1641 13.2815L34.2547 26.1909C34.1114 26.3343 33.9232 26.4062 33.7357 26.4062Z",
    fill: "#13373F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1847 33.9337C32.1478 33.9337 32.1099 33.9308 32.0719 33.9246C31.6713 33.8628 31.3965 33.4877 31.4582 33.0871C31.8033 30.8494 31.6248 28.5284 30.942 26.3757C30.2275 24.1205 29.0103 22.1225 27.3251 20.4378C25.6399 18.7526 23.6419 17.5355 21.3866 16.8204C19.2345 16.1381 16.9135 15.9596 14.6758 16.3047C14.2747 16.3665 13.8995 16.0916 13.8378 15.6905C13.776 15.2893 14.0508 14.9147 14.452 14.853C16.9124 14.4733 19.464 14.6699 21.8309 15.4202C23.039 15.8032 24.2006 16.3291 25.2835 16.9836C26.3981 17.6567 27.4345 18.4693 28.3638 19.3986C29.2931 20.3279 30.1057 21.3643 30.7794 22.4795C31.4339 23.5623 31.9597 24.724 32.3428 25.932C33.093 28.2989 33.2891 30.8505 32.91 33.3109C32.8539 33.6736 32.5411 33.9337 32.1847 33.9337Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_624_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 33,
    height: 33
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "e96f73f1d3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.3999 0H47.7498V32.4479H15.3999V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_624_19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5872 32.3483C29.4867 32.3483 27.4394 31.9499 25.5014 31.164C23.4949 30.3503 21.6947 29.1547 20.1512 27.6111C18.6076 26.0676 17.4125 24.2673 16.5983 22.2608C15.8129 20.3229 15.4146 18.2756 15.4146 16.1756C15.4146 14.0751 15.8129 12.0278 16.5983 10.0898C17.4125 8.08332 18.6076 6.28308 20.1512 4.73954C21.6947 3.19599 23.4949 2.00093 25.5014 1.18722C27.4394 0.401283 29.4867 0.00292969 31.5872 0.00292969C33.6872 0.00292969 35.7345 0.401283 37.6725 1.18722C39.679 2.00093 41.4792 3.19599 43.0227 4.73954C44.5669 6.28308 45.7619 8.08332 46.5756 10.0898C47.3616 12.0278 47.7599 14.0756 47.7599 16.1756C47.7599 18.2756 47.3616 20.3229 46.5756 22.2608C45.7619 24.2673 44.5669 26.0676 43.0227 27.6111C41.4792 29.1547 39.6795 30.3503 37.6725 31.164C35.7345 31.9499 33.6872 32.3483 31.5872 32.3483ZM31.5872 1.47848C27.8219 1.47848 24.0565 2.91153 21.1898 5.7782C15.457 11.5115 15.457 20.8397 21.1898 26.5725C26.9226 32.3058 36.2513 32.3058 41.9841 26.5725C47.7174 20.8397 47.7174 11.5115 41.9841 5.7782C39.118 2.91153 35.3526 1.47848 31.5872 1.47848Z",
    fill: "#13373F"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.888 32.0756C33.6999 32.0756 33.5123 32.0042 33.3684 31.8603C33.0816 31.5735 33.0816 31.1083 33.3684 30.8216L46.3514 17.8386C46.6387 17.5519 47.1033 17.5519 47.3901 17.8386C47.6768 18.1259 47.6768 18.5905 47.3901 18.8772L34.4076 31.8603C34.2637 32.0042 34.0761 32.0756 33.888 32.0756Z",
    fill: "#13373F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4211 14.6087C16.2335 14.6087 16.0454 14.5373 15.9021 14.394C15.6153 14.1067 15.6153 13.642 15.9021 13.3553L28.8845 0.372269C29.1718 0.0855457 29.6365 0.0855457 29.9237 0.372269C30.2105 0.658993 30.2105 1.12421 29.9237 1.41093L16.9407 14.394C16.7974 14.5373 16.6092 14.6087 16.4211 14.6087Z",
    fill: "#13373F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparency);
export default __webpack_public_path__ + "static/media/Transparency.76e4a042eab4b8ffb6f831ba463da59a.svg";
export { ForwardRef as ReactComponent };